import ModuleAccessPolicy from '@francelink/oswedev/dist/shared/modules/AccessPolicy/ModuleAccessPolicy';
import VueModuleBase from '@francelink/oswedev/dist/vuejsclient/ts/modules/VueModuleBase';
import FooterComponent from '../../../../vuejsclient/components/footer/footer';

export default class MYMALERBALogInVueModule extends VueModuleBase {

    public static getInstance() {
        if (!MYMALERBALogInVueModule.instance) {
            MYMALERBALogInVueModule.instance = new MYMALERBALogInVueModule();
        }
        return MYMALERBALogInVueModule.instance;
    }

    private static instance: MYMALERBALogInVueModule = null;

    private constructor() {
        super(ModuleAccessPolicy.getInstance().name);
    }

    public async initializeAsync() {
        this.routes = [
            {
                path: '/',
                name: 'login',
                component: () => import(/* webpackChunkName: "AccessPolicyLoginComponent" */ '@francelink/oswedev/dist/vuejsclient/login/AccessPolicy/login/AccessPolicyLoginComponent'),
                props: (route) => ({
                    footer_component: FooterComponent
                })
            },
            {
                path: '/signin',
                name: 'signin',
                component: () => import(/* webpackChunkName: "SignInComponent" */ './signin/signin')
            },
            {
                path: '/recover',
                name: 'recover',
                component: () => import(/* webpackChunkName: "AccessPolicyRecoverComponent" */ '@francelink/oswedev/dist/vuejsclient/login/AccessPolicy/recover/AccessPolicyRecoverComponent'),
                props: (route) => ({
                    footer_component: FooterComponent
                })
            },
            {
                path: '/reset',
                name: 'reset',
                component: () => import(/* webpackChunkName: "AccessPolicyResetComponent" */ '@francelink/oswedev/dist/vuejsclient/login/AccessPolicy/reset/AccessPolicyResetComponent'),
                props: (route) => ({
                    footer_component: FooterComponent
                })
            },
            {
                path: '/reset/:user_id/:challenge',
                name: 'reset simplified',
                component: () => import(/* webpackChunkName: "AccessPolicyResetComponent" */ '@francelink/oswedev/dist/vuejsclient/login/AccessPolicy/reset/AccessPolicyResetComponent'),
                props: (route) => ({
                    prop_user_id: parseInt(route.params.user_id),
                    prop_challenge: route.params.challenge,
                    footer_component: FooterComponent
                })
            }
        ];
    }
}